<template>
<a v-if="!loading && advert" :href="`/click/${advert.id}`" target="_blank">
<img :src="advert.image" class="banner img-fluid" alt="Banner" />
</a>
</template>

<script>
export default {
  props: ['campaign_id'],
  data() {
    return {
      advert: null,
      loading: true,
    };
  },

  created() {
    this.getaAvert();
  },

  methods: {
    getaAvert() {
      axios
        .post(`/campaigns/get-single-ad`, {
          orientation: 'Vertical',
          campaign_id: this.campaign_id,
        })
        .then((response) => {
          if (response.data.success) {
            this.advert = response.data.advert
          } 
        }).finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>